import CardDescription from '@/components/atoms/card-description/cardDescription';
import { ICommunicationChannelsProps } from '@/interfaces/qanty';
import './communicationChannels.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

const CommunicationChannels = ({ title, subtitle, listChannels }: ICommunicationChannelsProps) => {
  return (
    <article className="m-communication-channels">
      <aside className="m-communication-channels__content">
        <div className="m-communication-channels__content__header">
          <h2 className="title">{title}</h2>
          <p className="subtitle">{subtitle}</p>
        </div>
        <div className="m-communication-channels__content__list">
          {listChannels.map((list, index) => (
            <CardDescription
              key={index}
              title={list.titulo}
              description={list.descripcion}
              url={getAssetUrl(list.icono)}
            />
          ))}
        </div>
      </aside>
    </article>
  );
};

export default CommunicationChannels;
